<template>
  <div class="d-flex align-items-center min-vh-100">
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Forgot Password</h1>
                <p class="text-muted">Generate your password</p>                
                <CInput
                  placeholder="Email"
                  autocomplete="email" name="email"
                  prepend="@"
                >                
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CButton color="success" block @click="forgot()">Forgot Password</CButton>
				<CButton color="btn btn-outline-light btn-block active" @click="back()">Cancel</CButton>
              </CForm>
            </CCardBody>
            <!-- <CCardFooter class="p-4">
              <CRow>
                <CCol col="6">
                  <CButton block color="facebook">
                    Facebook
                  </CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="twitter">
                    Twitter
                  </CButton>
                </CCol>
              </CRow>
            </CCardFooter> -->
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'Forgotpassword',
   data(){
      return{	
				menuName:this.$route.MenuName,
				title:"Register",
        isLoading: false
			}
		},mounted () {
			//console.log('success');
		},
		methods:{
			back(){				
				this.$router.push({path:'Login'})
			},
			forgot() {	
        this.isLoading = true;			
				var email=$('input[name=email]').val();				
				if(email!=''){
				var requestInfo = {
            UserEmail : email
          };
					var data = JSON.stringify(requestInfo);				
          var self = this;
          var config = {
            method: 'post',
            url: apiURL+'Authentication/ForgotPassword',
            headers: { 
            'Content-Type': 'application/json'
            },
            data : data
          };
          axios(config)
          .then((result) => {	
            this.isLoading = false;		
            if(result.data.status_code==200){				
              this.$swal.fire({
                title: "Forget Password", 
                text: "Mail has been sent.", 
                type: "success"					  
              });		
            } else{
              this.isLoading = false;	
              this.$swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: result.data.message		 
              })				
            }
            
          })
          .catch((error) => {	
            this.isLoading = false;			
            this.$swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Something went wrong!'		 
            })
          });
				}else{
					return false;
				}
				
			}
		}	
}
</script>
